import React from 'react'
const IndustrySection = () => {
  return (
    <div className='flex flex-col items-center justify-center p-5 lg:p-10 max-w-7xl mx-auto gap-y-10 text-start lg:mt-10  '>
    <div>
    <h1 className='font-extrabold  text-2xl lg:text-4xl text-gray-700'>
    Industries We Serve
    </h1>
    </div>
    <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-gray-500 hover:border-primaryColor group '>
    <div className='flex p-2 sm:p-5 border-t-0 border-l-0 sm:p-5 flex-col justify-start items-start gap-x-2 border-b-2 border-r-2 group-hover:border-primaryColor'>
            {/* <img src={logistics} alt="" /> */}
            <svg
            className='w-1/3 sm:w-8 gray-500  my-3'
      fill="#273036"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M48.406,21.063h-0.031l-4.125-5.5v-0.031L44.219,15.5C43.297,14.387,41.914,13,40,13h-8c-0.355,0-0.684,0.074-1,0.188c-0.727,0.375-2.004,1.245-2,2.719V25v0.95V27h-2V16c0-0.552-0.448-1-1-1h-4V4c0-0.552-0.448-1-1-1H9C8.448,3,8,3.448,8,4v11H4c-0.552,0-1,0.448-1,1v11H1c-0.552,0-1,0.448-1,1v6c0,2.206,1.794,4,4,4h4.09c0.478,2.833,2.942,5,5.91,5s5.431-2.167,5.91-5h13.184c0.477,2.836,2.941,5,5.906,5c2.96,0,5.429-2.172,5.909-5H45h1h1c1.66,0,3-1.34,3-3v-9.625C50,23.086,48.406,21.063,48.406,21.063z M44.344,19l2.438,3.25c0,0,0.906,1.551,1.094,2.75H38c-0.168,0-0.438-0.125-0.656-0.344S37,24.168,37,24v-4c0-0.504,0.594-1,1-1H44.344z M25,27H15V17h10V27z M10,5h10v10h-4h-2h-4V5z M5,17h4h4v10H5V17z M14,41c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S16.206,41,14,41z M39,41c-2.223,0-4-1.777-4-4s1.777-4,4-4s4,1.777,4,4S41.223,41,39,41z M48,35c0,0.375-0.625,1-1,1h-1h-1h-0.091c-0.48-2.828-2.95-5-5.909-5c-2.965,0-5.43,2.164-5.906,5H33H19.91c-0.478-2.833-2.942-5-5.91-5s-5.431,2.167-5.91,5H4c-1.103,0-2-0.897-2-2v-5h2h10h2h10h4c0.552,0,1-0.448,1-1v-2.05V24v-8c0-0.375,0.625-1,1-1h8c0.785,0,1.891,0.84,2.656,1.75c0.008,0.012,0.023,0.02,0.031,0.031L42.844,17H38c-1.594,0-3,1.289-3,3v4c0,0.832,0.375,1.563,0.906,2.094S37.168,27,38,27h10V35z"></path>
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Logistics & Transportation</h1>
        </div>
        {/* Ecommerce */}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 border-b-2 sm:border-r-2 group-hover:border-primaryColor group'>
    <svg
     className='w-1/3 sm:w-8  gray-500  my-3'
    //   height="200px"
    //   width="200px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="#273036"
    >
      <g>
        <path d="M491.615,95.734c-5.06-6.18-12.634-9.772-20.622-9.772H123.664l-11.835-40.657v0.008c-5.433-18.176-20.341-31.947-38.883-35.92L30.48,0.3C23.297-1.245,16.217,3.339,14.671,10.53c-1.536,7.19,3.04,14.271,10.24,15.807l42.449,9.102c9.032,1.935,16.3,8.642,18.949,17.506l77.597,266.547c-1.748,0.815-3.438,1.698-5.068,2.674c-8.362,4.984-15.07,11.98-19.568,20.147c-4.305,7.76-6.589,16.555-6.809,25.631h-0.034v1.383h0.034c0.17,7.09,1.681,13.89,4.304,20.096c4.202,9.925,11.181,18.321,19.976,24.264c8.788,5.951,19.476,9.44,30.853,9.432h249.568c7.361,0,13.32-5.96,13.32-13.312c0-7.352-5.96-13.312-13.32-13.312l-249.568-0.008c-3.974,0-7.692-0.798-11.105-2.233c-5.102-2.156-9.492-5.79-12.565-10.358c-2.954-4.39-4.703-9.56-4.839-15.23c0.152-6.767,2.309-12.642,6.095-17.337c1.961-2.42,4.38-4.542,7.318-6.3c2.904-1.732,6.326-3.107,10.341-3.973l250.841-40.828c16.386-2.674,29.426-15.205,32.737-31.481l30.682-150.839v-0.016c0.356-1.749,0.527-3.532,0.527-5.298C497.626,106.499,495.536,100.54,491.615,95.734z M440.319,263.442c-1.104,5.434-5.451,9.611-10.918,10.494l-239.669,39.02l-58.325-200.361h339.586h0.009L440.319,263.442z" />
        <path d="M218.411,444.786c-5.85-3.957-12.972-6.291-20.546-6.282c-5.052,0-9.916,1.026-14.314,2.895c-6.605,2.793-12.191,7.436-16.156,13.303c-3.964,5.85-6.291,12.973-6.274,20.546c-0.008,5.043,1.019,9.908,2.887,14.306c2.801,6.614,7.436,12.2,13.295,16.156c5.858,3.974,12.989,6.292,20.562,6.292c5.043,0,9.9-1.028,14.297-2.895c6.614-2.793,12.2-7.446,16.165-13.304c3.956-5.85,6.282-12.981,6.282-20.554c0-5.042-1.036-9.898-2.895-14.305C228.913,454.328,224.269,448.742,218.411,444.786z" />
        <path d="M419.943,444.786c-5.858-3.957-12.98-6.291-20.553-6.282c-5.043,0-9.908,1.026-14.306,2.895c-6.613,2.793-12.2,7.436-16.164,13.303c-3.956,5.85-6.282,12.973-6.282,20.546c0,5.043,1.036,9.908,2.895,14.306c2.793,6.614,7.446,12.2,13.304,16.165c5.85,3.965,12.981,6.283,20.554,6.283c5.042,0,9.907-1.028,14.305-2.895c6.605-2.793,12.191-7.446,16.156-13.304c3.964-5.85,6.29-12.981,6.282-20.554c0-5.042-1.027-9.898-2.895-14.305C430.436,454.328,425.801,448.742,419.943,444.786z" />
      </g>
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Retail & E-commerce</h1>
        </div> 
        {/* Health*/}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 border-b-2 border-r-2 group-hover:border-primaryColor'>
            {/* <img src={logistics} alt="" /> */}
            <svg
                className='w-1/3 sm:w-8 gray-500  my-1 sm:my-3 '
             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 22L2 22" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M17 22V6C17 4.11438 17 3.17157 16.4142 2.58579C15.8284 2 14.8856 2 13 2H11C9.11438 2 8.17157 2 7.58579 2.58579C7 3.17157 7 4.11438 7 6V22" stroke="#273036" strokeWidth="1.2"></path>
      <path d="M21 22V8.5C21 7.09554 21 6.39331 20.6629 5.88886C20.517 5.67048 20.3295 5.48298 20.1111 5.33706C19.6067 5 18.9045 5 17.5 5" stroke="#273036" strokeWidth="1.2"></path>
      <path d="M3 22V8.5C3 7.09554 3 6.39331 3.33706 5.88886C3.48298 5.67048 3.67048 5.48298 3.88886 5.33706C4.39331 5 5.09554 5 6.5 5" stroke="#273036" strokeWidth="1.2"></path>
      <path d="M12 22V19" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M10 12H14" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M5.5 11H7" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M5.5 14H7" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M17 11H18.5" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M17 14H18.5" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M5.5 8H7" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M17 8H18.5" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M10 15H14" stroke="#273036" strokeWidth="1.2" strokeLinecap="round"></path>
      <path d="M12 9V5" stroke="#273036" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M14 7L10 7" stroke="#273036" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Healthcare</h1>
        </div>

        {/* Finance and banking */}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 border-b-2  group-hover:border-primaryColor'>
            {/* <img src={logistics} alt="" /> */}
            <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      className='w-1/3 sm:w-12  gray-500 my-1  '
    >
      <g>
        <path
          d="M47.8,34.1c0,9.9-8,17.9-17.9,17.9S12,44,12,34.1s8-17.9,17.9-17.9v17.9H47.8z"
          className="stroke-current"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52,29.9C52,20,44,12,34.1,12v17.9H52z"
          className="stroke-current"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="29.9"
          y1="34.1"
          x2="17.2"
          y2="46.8"
          className="stroke-current"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <line
        x1="21.6"
        y1="42.4"
        x2="31"
        y2="51.9"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="26.1"
        y1="37.9"
        x2="38"
        y2="49.9"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="43,46 34,37 31.2,34.2"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="46.2"
        y1="41.4"
        x2="39.1"
        y2="34.2"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Finance & Banking</h1>
        </div>

        {/*Real Estate*/}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 border-r-2 border-b-2 sm:border-b-0 group-hover:border-primaryColor '>
            {/* <img src={logistics} alt="" /> */}
            <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-8 h-8 my-3 stroke-current text-gray-800"
    >
      <path
        d="M12.5 22.0001H4.07997C2.91997 22.0001 1.96997 21.0701 1.96997 19.9301V5.09011C1.96997 2.47011 3.91997 1.2801 6.30997 2.4501L10.75 4.63011C11.71 5.10011 12.5 6.3501 12.5 7.4101V22.0001Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.97 15.0602V18.8402C21.97 21.0002 20.97 22.0002 18.81 22.0002H12.5V10.4202L12.97 10.5202L17.47 11.5302L19.5 11.9802C20.82 12.2702 21.9 12.9502 21.96 14.8702C21.97 14.9302 21.97 14.9902 21.97 15.0602Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 9H8.97"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 13H8.97"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.47 11.53V14.75C17.47 15.99 16.46 17 15.22 17C13.98 17 12.97 15.99 12.97 14.75V10.52L17.47 11.53Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.96 14.87C21.9 16.05 20.92 17 19.72 17C18.48 17 17.47 15.99 17.47 14.75V11.53L19.5 11.98C20.82 12.27 21.9 12.95 21.96 14.87Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
            </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Real Estate</h1>
        </div>
        {/* Education */}
 
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 sm:border-r-2 border-b-2 sm:border-b-0 group-hover:border-primaryColor '>
            {/* <img src={logistics} alt="" /> */}
            <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-8 h-8  my-3 stroke-current text-gray-800"
    >
      <path
        d="M504.499 378.496L382.003 256 486.4 151.603c19.959-19.968 19.959-52.446 0-72.405L432.802 25.6c-9.651-9.651-22.511-14.967-36.207-14.967-13.696 0-26.547 5.316-36.198 14.967L256 129.997 133.504 7.501C128.7 2.697 122.189 0 115.405 0c-6.792 0-13.303 2.697-18.099 7.501L7.501 97.297c-10.001 10.001-10.001 26.206 0 36.207L129.997 256 7.501 378.496C2.697 383.3 0 389.811 0 396.604V486.4C0 500.54 11.46 512 25.6 512h89.805c6.793 0 13.303-2.697 18.099-7.501L256 382.003l122.496 122.496c10.001 10.001 26.206 10.001 36.207 0l89.796-89.796c4.804-4.804 7.501-11.315 7.501-18.108 0-6.793-2.697-13.304-7.501-18.108zM378.496 43.708c4.983-4.984 11.546-7.475 18.108-7.475s13.124 2.492 18.099 7.467l53.598 53.598c9.958 9.958 9.958 26.249 0 36.207l-17.544 17.544-89.805-89.796 17.544-17.545zM377.6 114.099l20.301 20.301L96 436.301 75.699 416 377.6 114.099zM25.6 115.396L115.405 25.6l13.252 13.252-28.902 28.902c-5 5-5 13.099 0 18.099 2.5 2.5 5.777 3.746 9.054 3.746s6.554-1.246 9.054-3.746l28.902-28.902 20.301 20.301-16.102 16.102c-5.001 5.001-5.001 13.099 0 18.099 2.5 2.5 5.777 3.746 9.054 3.746s6.554-1.246 9.054-3.746l16.102-16.102 20.301 20.301-28.902 28.902c-5.001 5-5.001 13.099 0 18.099 2.5 2.5 5.777 3.746 9.054 3.746s6.554-1.246 9.054-3.746l28.902-28.902 14.345 14.345-89.83 89.805L25.6 115.396zM342.852 79.351L359.501 96 57.6 397.901l-16.648-16.648L342.852 79.351zM25.6 486.4v-84.301l84.301 84.301H25.6zM130.748 471.049L114.099 454.4 416 152.499l16.649 16.649-301.901 301.901zM396.604 486.4L274.099 363.904l89.805-89.805 14.345 14.345-28.902 28.902c-2.5 2.5-3.746 5.777-3.746 9.054 0 3.277 1.246 6.554 3.746 9.054 5 5.001 13.099 5.001 18.099 0l28.902-28.902 20.301 20.301-16.102 16.102c-2.5 2.5-3.746 5.777-3.746 9.054 0 3.277 1.246 6.554 3.746 9.054 5 5 13.099 5 18.099 0l16.102-16.102 20.301 20.301-28.902 28.902c-2.5 2.5-3.746 5.777-3.746 9.054 0 3.277 1.246 6.554 3.746 9.054 5.001 5 13.099 5 18.099 0l28.902-28.902 13.252 13.227L396.604 486.4z"
        fill="currentColor"
      />
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Education</h1>
        </div>
        {/*Manufacturing*/}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 border-r-2 group-hover:border-primaryColor '>
            {/* <img src={logistics} alt="" /> */}
            <svg
            className='w-12 my-1'
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.36 24c0-1.302-1.059-2.36-2.36-2.36S1.64 22.698 1.64 24 2.699 26.36 4 26.36 6.36 25.302 6.36 24zM2.36 24c0-0.904 0.736-1.64 1.64-1.64S5.64 23.096 5.64 24 4.904 25.64 4 25.64 2.36 24.904 2.36 24zM14.36 24c0-1.302-1.059-2.36-2.36-2.36s-2.36 1.059-2.36 2.36 1.059 2.36 2.36 2.36 2.36-1.059 2.36-2.36zM10.36 24c0-0.904 0.736-1.64 1.64-1.64s1.64 0.735 1.64 1.64-0.736 1.64-1.64 1.64-1.64-0.735-1.64-1.64zM22.36 24c0-1.302-1.059-2.36-2.36-2.36s-2.36 1.059-2.36 2.36 1.059 2.36 2.36 2.36 2.36-1.059 2.36-2.36zM18.36 24c0-0.904 0.735-1.64 1.64-1.64s1.64 0.735 1.64 1.64-0.735 1.64-1.64 1.64-1.64-0.735-1.64-1.64zM30.36 24c0-1.302-1.059-2.36-2.36-2.36s-2.36 1.059-2.36 2.36 1.059 2.36 2.36 2.36 2.36-1.059 2.36-2.36zM26.36 24c0-0.904 0.735-1.64 1.64-1.64s1.64 0.735 1.64 1.64-0.735 1.64-1.64 1.64-1.64-0.735-1.64-1.64zM31 19.64v0.721H1V19.64H31zM1 27.64h30v0.721H1V27.64zM12 18.36h8c0.199 0 0.36-0.161 0.36-0.36v-8c0-0.199-0.161-0.36-0.36-0.36h-8c-0.199 0-0.36 0.161-0.36 0.36v8c0 0.199 0.161 0.36 0.36 0.36zM12.36 10.36h7.28v7.28h-7.28V10.36zM22 11.36h8c0.199 0 0.36-0.161 0.36-0.36V3c0-0.199-0.161-0.36-0.36-0.36h-8c-0.199 0-0.36 0.161-0.36 0.36v8c0 0.199 0.161 0.36 0.36 0.36zM22.36 5.149l1.789-1.789h1.981l-3.77 3.77V5.149zM22.36 8.149l4.789-4.789h1.981l-6.77 6.77V8.149zM29.64 8.851l-1.789 1.789H25.87l3.77-3.77V8.851zM29.64 5.851l-4.789 4.789H22.87l6.77-6.77V5.851zM28.869 10.64l0.771-0.77v0.771L28.869 10.64zM23.131 3.36L22.36 4.13V3.36H23.131zM2 18.36h8c0.199 0 0.36-0.161 0.36-0.36v-8c0-0.199-0.161-0.36-0.36-0.36H2c-0.199 0-0.36 0.161-0.36 0.36v8c0 0.199 0.161 0.36 0.36 0.36zM2.36 10.36h7.28v7.28H2.36V10.36z"
        fill="#273036"
      />
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Manufacturing</h1>
        </div>
        {/*Automotive*/}
        <div className='flex p-2 sm:p-5 flex-col justify-start items-start gap-x-2 group-hover:border-primaryColor '>
            {/* <img src={logistics} alt="" /> */}
            <svg
      className='w-10 my-2'
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#273036"
        d="M58.982 32.088C58.985 32.057 59 32.031 59 32c0-2.866-.589-28-21-28H26C12.654 4 5 14.206 5 32c0 .031.015.057.018.088C2.176 32.559 0 35.027 0 38v10c0 3.309 2.691 6 6 6v5c0 .553.447 1 1 1h8c.553 0 1-.447 1-1v-5h32v5c0 .553.447 1 1 1h8c.553 0 1-.447 1-1v-5c3.309 0 6-2.691 6-6V38c0-2.973-2.176-5.441-5.018-5.912zM26 6h12c18.467 0 19 23.339 19 26h-2c0-2.456-.505-24-18-24H27C15.393 8 9 16.523 9 32H7C7 9.378 18.904 6 26 6zM24 24c-4.418 0-8 3.582-8 8h-5c0-18.184 8.701-22 16-22h10c6.34 0 10.909 3.16 13.581 9.394C52.825 24.632 53 30.367 53 32H32c0-4.418-3.582-8-8-8zM30 32H18c0-3.313 2.687-6 6-6s6 2.687 6 6zM14 58H8v-4h6v4zM56 58h-6v-4h6v4zM62 48c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4V38c0-2.206 1.794-4 4-4h52c2.206 0 4 1.794 4 4v10z"
      />
      <path
        fill="#273036"
        d="M11 39c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM53 39c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM43 40H21c-.553 0-1 .447-1 1s.447 1 1 1h22c.553 0 1-.447 1-1s-.447-1-1-1zM43 44H21c-.553 0-1 .447-1 1s.447 1 1 1h22c.553 0 1-.447 1-1s-.447-1-1-1zM42.707 15.294c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2 2c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-2-2zM37.707 15.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l7 7C43.488 23.902 43.744 24 44 24s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-7-7z"
      />
    </svg>
            <h1 className='sm:text-xl  text-start  font-semibold  text-[#273036]'>Automotive</h1>
        </div>
    </div>
</div>
  )
}

export default IndustrySection